import { useEffect, useState } from 'react';
import { apiRequest } from '@/lib/api-request';
import { useUser } from '@/contexts/UserContext';

/**
 * The current company's own country (companies.country) -- the single
 * source date-format.ts's getDateFormatForCountry() reads, and the only
 * place in the app that queries it. Reused by every date input instead
 * of each screen fetching the company row itself.
 */
export function useCompanyCountry(): string | null {
  const { companyId } = useUser();
  const [country, setCountry] = useState<string | null>(null);

  useEffect(() => {
    if (!companyId) {
      setCountry(null);
      return;
    }
    let cancelled = false;
    apiRequest<{ country?: string | null }>('api/company/profile')
      .then((company) => {
        if (!cancelled) setCountry(company?.country ?? null);
      })
      .catch(() => {
        if (!cancelled) setCountry(null);
      });
    return () => {
      cancelled = true;
    };
  }, [companyId]);

  return country;
}
